/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationPartnerCreateRequest model module.
 * @module model/EventsControllerDtoEventInvitationPartnerCreateRequest
 * @version 1.0
 */
class EventsControllerDtoEventInvitationPartnerCreateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationPartnerCreateRequest</code>.
     * @alias module:model/EventsControllerDtoEventInvitationPartnerCreateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationPartnerCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationPartnerCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerCreateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationPartnerCreateRequest} The populated <code>EventsControllerDtoEventInvitationPartnerCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationPartnerCreateRequest();

            if (data.hasOwnProperty('partnerEmail')) {
                obj['partnerEmail'] = ApiClient.convertToType(data['partnerEmail'], 'String');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationPartnerCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationPartnerCreateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['partnerEmail'] && !(typeof data['partnerEmail'] === 'string' || data['partnerEmail'] instanceof String)) {
            throw new Error("Expected the field `partnerEmail` to be a primitive type in the JSON string but got " + data['partnerEmail']);
        }
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }

        return true;
    }


}



/**
 * @member {String} partnerEmail
 */
EventsControllerDtoEventInvitationPartnerCreateRequest.prototype['partnerEmail'] = undefined;

/**
 * @member {String} invCode
 */
EventsControllerDtoEventInvitationPartnerCreateRequest.prototype['invCode'] = undefined;






export default EventsControllerDtoEventInvitationPartnerCreateRequest;

